import http from '@/utils/request'

//登录+获取menu
export const login = (params) => {
    return http.post('/home/login',params)
}
//注册
export const register = (params) => {
    return http.post('/home/register',params)
}
//改密码
export const updatepwd = (params) => {
    return http.post('/account/updatepwd',params)
}
//首页信息
export const getMainQuery = (params) => {
    return http.get('/account/querymain',params)
}
//总表-精确查询
export const getUserQuery = (params) => {
    return http.get('/queryamhlist',params)
}
//总表-分页
export const getUserList = (params) => {
    return http.get('/getamhlistpage',params)
}
//单份下载报告
export const getReport = (params) => {
    return http.get('file/getfile',params)
}
//下载总表
export const getAmhAllFile = (params) => {
    return http.get('file/getamhall',params)
}
//生成报告
export const createReport = (params) => {
    return http.post('file/createreport',params)
}
//ad上传新增用户数据
export const addAmhList  = (params) => {
    return http.post('/addamhlist',params)
}
//ad上传更新用户数据
export const updateAmhList = (params) => {
    return http.post('/updateamhlist',params)
}
//ad下载月结账单
export const getFinance = (params) => {
    return http.get('file/getfinance',params)
}
//上传条码
export const setNumber = (params) => {
    return http.post('file/setnumber',params)
}
//上传乱序条码
export const setNumberSingle = (params) => {
    return http.post('file/setnumbersingle',params)
}
// export const getMenu = (data) => {
//     return http.post('/permission/getMenu',data)
// }